/**
 * Created by anthony on 7/18/14.
 */
var realEstateModel = angular.module('realEstateModel', ['familyModel']);
realEstateModel.factory('RealEstateModelFactory', function(ApplicationService, FamilyModelFactory, AbstractModelService){
    var RealEstateModel = function(familyID){
        this.familyID = familyID;
        this.dataProperty = "real_estate";
        this.endpoint = "/realestate";
        this.primaryKey = "recordID";
        this.data = angular.copy(this.get());
    }
    RealEstateModel.prototype = new FamilyModelFactory();
    RealEstateModel.prototype.parent = FamilyModelFactory.prototype;


    RealEstateModel.prototype.newFamilyHome = function()
    {
        var index = this.new();
        this.data[index].Rea_Description = "Family Home";
        return index;
    }

    RealEstateModel.prototype.new = function()
    {
        return ApplicationService.getFamilyData().real_estate.push(
            {
                Rea_Mort_Pay: '', Rea_Mort_Interest: '', Rea_Mort_Val: '', Rea_Description: '', xRea_Description: 'New', Rea_Year_Purch: '',
                Rea_Purch_Price: '', Rea_PMV: '', Rea_Refinanced: '', Rea_Refinanced_Year: '', Rea_Refinanced_Amt : '',
                Rea_Principle: '', Rea_Property_Tax: '', Rea_Home_Ins: '', Rea_Property_Inc: '', Rea_Addy1: '',
                Rea_City: '', Rea_State: '', Rea_Zip: '', Rea_Country : '', added: 1
            }
        ) - 1;
    }

    RealEstateModel.prototype.put = function(id, data, instance)
    {
        return AbstractModelService.put("/api/family/" + this.familyID + "/realestate/" + id, data, instance);
    }

    RealEstateModel.prototype.post = function(id, data, instance)
    {
        return AbstractModelService.post("/api/family/" + this.familyID + "/realestate", data, instance);
    }

    RealEstateModel.prototype.purge = function(id, data, instance)
    {
        return AbstractModelService.purge("/api/family/" + this.familyID + "/realestate/" + id, data, instance);
    }

    RealEstateModel.prototype.updateData = function() //Abstract
    {
        if (!ApplicationService.isFamilyTwoSituation())
            ApplicationService.getAwardData().family[0][this.dataProperty] = angular.copy(this.data);
        else if (ApplicationService.getAwardData().family[0].data[0].familyID == this.familyID)
            ApplicationService.getAwardData().family[0][this.dataProperty] = angular.copy(this.data);
        else
            ApplicationService.getAwardData().family[1][this.dataProperty] = angular.copy(this.data);

        this.data = angular.copy(this.get());
    }

    RealEstateModel.prototype.isDirty = function() //Abstract
    {
        return !angular.equals(this.data, this.get());
    }
    return RealEstateModel;
});

